module.exports = {
  VOLUME: '{volume}',
  CURRENT_TIME: '{currentTime}',
  TOTAL_TIME: '{totalTime}',
  LEVEL: '{level}',
  RESOLUTION: '{resolution}',
  RESOLUTION_TIER: '{resolutionTier}',
  BITRATE: '{bitrate}',
  PERCENT: '{percent}',
  SETTING: '{setting}',
  SECONDS: '{seconds}',
  RATE: '{rate}',
};
